export enum TravelInputModeEnum {
  DEFAULT = 'DEFAULT',
  HOUSE_SEARCH = 'HOUSE_SEARCH',
}
